<template>
    <FormSection title="Evacuation" type="his-section" :full-height="false" :application-id="Number(application)">
        <template #content>
            <div class="col col-12">
                <section class="row py-3 g-0">
                    <div class="col-12 col-lg-12 pe-lg-2 px-4 col-md-12 g-0"></div>
                    <div class="col-12 col-lg-12 px-4 col-md-12 g-0 mt-2">
                        <label class="mb-1" for="contact_relationship"><b> Evacuation Zone </b></label>
                        <select class="form-select me-2" v-model="referral.EmergencyPreparedness.EvacuationZone">
                            <option :value="null">Select Zone</option>
                            <option v-for="(zone, index) of zones" :key="index" :value="zone.value">
                                {{ zone.name }}
                            </option>
                        </select>
                        <p class="mb-1 mt-3"><b>Evacuation Address</b></p>
                        <div class="w-100 pb-2">
                            <div class="form-check custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="contact-address"
                                    @click="SameAsEmergencyContactEvacChanged()"
                                    v-model="referral.EmergencyPreparedness.SameAsEmergencyContactEvac"
                                />
                                <label class="form-check-label" for="contact-address">
                                    Same as Emergency Contact
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <ReferralAddressForm
                                :address="referral.EmergencyPreparedness.EvacuationAddress"
                                :address-type="'evacuation'"
                                :show-code="false"
                                :show-zip-four-code="false"
                                :state-class="stateClass"
                                :countyData="EvacuationCounty"
                                :zipChanged="getCounty"
                            />
                        </div>
                        <div class="row col-12">
                            <div class="form-group col-12 col-lg-6 pe-lg-2">
                                <label for="contact-mobile-number"> Mobile Phone </label>
                                <input
                                    id="contact-mobile-number"
                                    type="text"
                                    :value="formatPhone(referral.EmergencyPreparedness.EvacuationPhoneMobile)"
                                    class="form-control phone-number-input"
                                    maxlength="14"
                                    placeholder="Enter Number"
                                    @input="setMobilePhone($event.target.value)"
                                    v-number-only
                                />
                            </div>
                            <div class="form-group col-12 col-lg-6 pe-lg-2">
                                <label for="contact-alternate-mobile"> Alternate Phone </label>
                                <input
                                    id="contact-alternate-mobile"
                                    type="text"
                                    :value="formatPhone(referral.EmergencyPreparedness.EvacuationPhoneHome)"
                                    class="form-control phone-number-input"
                                    maxlength="14"
                                    placeholder="Enter Number"
                                    @input="setAlternatePhone($event.target.value)"
                                    v-number-only
                                />
                            </div>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="as-visit-location"
                                    v-model="referral.EmergencyPreparedness.SetAsVisitLocation"
                                />
                                <label class="form-check-label" for="as-visit-location"> Set as visit location </label>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EmergencyEvacuation.ts"></script>
